/** Legacy vs current activation fee (subscription). */
export const LEGACY_ACTIVATION_FEE = 499;
/** Previous Ultra tier (orders / cashback before price change). */
export const PREVIOUS_CURRENT_ACTIVATION_FEE = 649;
export const CURRENT_ACTIVATION_FEE = 699;
/** Legacy ₹499 → Ultra + AFP add-on (unchanged when Ultra went ₹649 → ₹699). */
export const AUTO_FILL_UPGRADE_AMOUNT = 150;

export function isCurrentTierActivationFee(fee) {
  const n = Number(fee);
  return (
    n === CURRENT_ACTIVATION_FEE || n === PREVIOUS_CURRENT_ACTIVATION_FEE
  );
}

export const AUTO_FILL_UPGRADE_PACKAGE_ID = "auto-fill-program-upgrade";

/** First-time Ultra membership cashback matches activation fee tier. */
export const FIRST_TIME_MEMBERSHIP_CASHBACK_BY_ACTIVATION_FEE = {
  [LEGACY_ACTIVATION_FEE]: LEGACY_ACTIVATION_FEE,
  [PREVIOUS_CURRENT_ACTIVATION_FEE]: PREVIOUS_CURRENT_ACTIVATION_FEE,
  [CURRENT_ACTIVATION_FEE]: CURRENT_ACTIVATION_FEE,
};
